module.exports = __webpack_public_path__ + "assets/img/list_sukikamo.55c6444a.svg";